export { HidePageGuard } from './hide-page.guard';
